import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Copy, Flex, Image, Box } from '@elparking/components'
import { Ok } from '../Icons'
import { COLORS } from 'commons/js/theme/default'
import { SUPPLIER_SIXT } from 'rental-car-contract/js/constants'

const messages = {
    [SUPPLIER_SIXT]: {
        creditCardTitle: <FormattedMessage defaultMessage={'Tarjeta de crédito'} />,
        creditCardSubtitle: () => <FormattedMessage defaultMessage={'Asegúrate de que tu tarjeta se encuentra entre los medios de pago aceptados por la compañía de la reserva.'} />,
    },
    default: {
        creditCardTitle: <FormattedMessage defaultMessage={'Tarjeta de crédito o débito'} />,
        creditCardSubtitle: ({companyName}) => <FormattedMessage defaultMessage={'Por favor, asegúrate de que tu tarjeta se encuentra entre los medios de pago aceptados por {companyName}.'} values={{companyName}}/>,
    },
}
const NeededDocs = ({
    idSupplier,
    companyName,
    showImage,
    textColor,
}) => <Flex flexDirection={['column', 'row']} alignItems='center'>
    {showImage && <Box display={['block', 'block', 'none']}>
        <Flex width='100%' justifyContent='center'>
            <Image width='100%' located={false} src='/images/rental-car/card.svg' alt='docs' />
        </Flex>
    </Box>}
    <Flex flexDirection='column' fontWeight='regular' padding='1em 0em'>
        <Copy fontWeight='medium' fontSize={['large', 'xxLarge']} padding='0' mb='0.5em'>
            <FormattedMessage defaultMessage='¿Qué documentación tengo que llevar?'/>
        </Copy>
        <Copy fontSize='small' fontWeight='regular' mb='1em'>
            <FormattedMessage
              defaultMessage='El conductor y titular de la reserva deberá llevar:'/>
        </Copy>
        <Flex mb='1em'>
            <Ok color={textColor}/>
            <Copy fontSize='small' fontWeight='medium' padding='0' ml='0.5em' width='fit-content' fontColor={textColor}><FormattedMessage defaultMessage='DNI o pasaporte en vigor'/></Copy>
        </Flex>
        <Flex mb='1em'>
            <Ok color={textColor}/>
            <Copy fontSize='small' fontWeight='medium' padding='0' ml='0.5em' width='fit-content' fontColor={textColor}><FormattedMessage defaultMessage='Carnet de conducir en vigor'/></Copy>
        </Flex>
        <Flex mb='1em'>
            <Box><Ok color={textColor}/></Box>
            <Flex flexDirection='column'>
                <Copy fontSize='small' fontWeight='bold' padding='0' ml='0.5em' width='fit-content' fontColor={textColor}>
                    {messages[idSupplier]?.creditCardTitle || messages.default.creditCardTitle}
                </Copy>
                <Copy fontSize='small' fontWeight='regular'>
                    {messages[idSupplier]?.creditCardSubtitle({companyName}) || messages.default.creditCardSubtitle({companyName})}
                </Copy>
            </Flex>
        </Flex>
    </Flex>
    <Box paddingLeft='20px' display={['none', 'none', 'block']}>
        <Image width='200px' located={false} src='/images/rental-car/card.svg' alt='docs'/>
    </Box>
</Flex>

NeededDocs.propTypes = {
    companyName: PropTypes.string,
    showImage: PropTypes.bool,
    textColor: PropTypes.oneOfType([
        PropTypes.oneOf(['inherit', ...COLORS]),
        PropTypes.arrayOf(PropTypes.oneOf(COLORS)),
    ]),
    idSupplier: PropTypes.number,
}

NeededDocs.defaultProps = {
    showImage: true,
    textColor: 'accent_dark70',
}

export default NeededDocs
